import { api } from '../index';

const DATAIMPORT_BASE_URL = 'api/data-import';

function getFormDataForUpload(customOptions = {}) {
  const formData = new FormData();
  const options = {
    file: '',
    ...customOptions,
  };

  Object.keys(options).map(function (key) {
    if (key === 'file' && options[key] !== '') {
      try {
        const filename = `${new Date().getTime()}-${options[key]['name']}`;
        formData.append(key, options[key], filename);
      } catch (error) {
        // if this fails in any old browser, try to fall back to default
        formData.append(key, options[key]);
      }
    } else {
      formData.append(key, options[key]);
    }
  });

  return formData;
}

async function getStudentImports(page = 1): Promise<any> {
  const url = `${DATAIMPORT_BASE_URL}/students?page=${page}`;

  const result = await api.get<any>(url);
  return result.data;
}

async function getMediaImports(page = 1): Promise<any> {
  const url = `${DATAIMPORT_BASE_URL}/media?page=${page}`;

  const result = await api.get<any>(url);
  return result.data;
}

async function importsStudentsCSV(file: File): Promise<PaginatedResponse<any>> {
  const url = `${DATAIMPORT_BASE_URL}/students`;
  const formData = getFormDataForUpload({ file });
  const result = await api.post<PaginatedResponse<any>>(url, formData);
  return result.data;
}

async function importsMediaCSV(file: File): Promise<PaginatedResponse<any>> {
  const url = `${DATAIMPORT_BASE_URL}/media`;
  const formData = getFormDataForUpload({ file });
  const result = await api.post<PaginatedResponse<any>>(url, formData);
  return result.data;
}

async function getClassCardImports(page = 1): Promise<PaginatedResponse<any>> {
  const url = `${DATAIMPORT_BASE_URL}/classcards?page=${page}`;

  const result = await api.get<any>(url);
  return result.data;
}

async function importsClassCardsCSV(
  file: File
): Promise<PaginatedResponse<any>> {
  const url = `${DATAIMPORT_BASE_URL}/classcards`;
  const formData = getFormDataForUpload({ file });
  const result = await api.post<PaginatedResponse<any>>(url, formData);
  return result.data;
}

async function getPurchasesImports(page = 1): Promise<PaginatedResponse<any>> {
  const url = `${DATAIMPORT_BASE_URL}/purchases?page=${page}`;

  const result = await api.get<PaginatedResponse<any>>(url);
  return result.data;
}

async function importsPurchasesCSV(
  file: File
): Promise<PaginatedResponse<any>> {
  const url = `${DATAIMPORT_BASE_URL}/purchases`;
  const formData = getFormDataForUpload({ file });
  const result = await api.post<PaginatedResponse<any>>(url, formData);
  return result.data;
}

async function getSubscriptionsImports(
  page = 1
): Promise<PaginatedResponse<any>> {
  const url = `${DATAIMPORT_BASE_URL}/subscriptions?page=${page}`;

  const result = await api.get<PaginatedResponse<any>>(url);
  return result.data;
}

async function importsSubscriptionsCSV(
  file: File
): Promise<PaginatedResponse<any>> {
  const url = `${DATAIMPORT_BASE_URL}/subscriptions`;
  const formData = getFormDataForUpload({ file });
  const result = await api.post<PaginatedResponse<any>>(url, formData);
  return result.data;
}

export default {
  getStudentImports,
  getMediaImports,
  getClassCardImports,
  getPurchasesImports,
  getSubscriptionsImports,
  importsStudentsCSV,
  importsMediaCSV,
  importsClassCardsCSV,
  importsPurchasesCSV,
  importsSubscriptionsCSV,
};
